import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = {
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_3 = {
  class: "caption"
};
const _hoisted_4 = {
  style: {
    "color": "#519eff"
  }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = {
  key: 0,
  class: "el-icon-success check-icon"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 4,
  class: "sms-con"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "right"
};
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = {
  style: {
    "color": "red"
  }
};
const _hoisted_15 = {
  class: "el-pagination-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_card = _resolveComponent("el-card");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createBlock(_component_el_card, {
    shadow: "never"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: _ctx.tabNum,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.tabNum = $event),
      onTabClick: $setup.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        name: "1"
      }, {
        label: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("span", null, [_createElementVNode("i", {
          class: "el-icon-finished"
        }), _createTextVNode(" 使用中")], -1)]))]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        name: "2"
      }, {
        label: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("span", null, [_createElementVNode("i", {
          class: "el-icon-date"
        }), _createTextVNode(" 未开始")], -1)]))]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        name: "3"
      }, {
        label: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("span", null, [_createElementVNode("i", {
          class: "el-icon-delete"
        }), _createTextVNode("已下架")], -1)]))]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [!_ctx.check ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      type: "success",
      icon: "el-icon-check",
      size: "small",
      onClick: $setup.checkModel
    }, {
      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("选择", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.check ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      type: "danger",
      icon: "el-icon-delete",
      size: "small",
      onClick: _cache[1] || (_cache[1] = $event => $setup.checkedAll(false))
    }, {
      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("取消", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.check ? (_openBlock(), _createBlock(_component_el_button, {
      key: 2,
      type: "success",
      icon: "el-icon-check",
      size: "small",
      onClick: _cache[2] || (_cache[2] = $event => $setup.checkedAll(true))
    }, {
      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("全选", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
      loading: _ctx.isBatchDownloading,
      type: "primary",
      size: "small",
      onClick: _cache[3] || (_cache[3] = $event => $setup.downloadAssets('checked'))
    }, {
      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("下载选中素材", -1)]))]),
      _: 1
    }, 8, ["loading"])), [[_directive_has, 'put:list:batch:dow']])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_cache[11] || (_cache[11] = _createTextVNode("所属渠道：", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.userAreaName), 1)]), _cache[12] || (_cache[12] = _createElementVNode("div", null, [_createTextVNode("特别说明："), _createElementVNode("span", null, "源文件类素材为提供各渠道定制化改造所用，若与图片素材有重复，选择其一即可。")], -1))])]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, idx) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["item", {
          'checking': _ctx.check && !item.checked,
          'checked': _ctx.check && item.checked
        }]),
        key: idx,
        onClick: $event => $setup.checked(item.id)
      }, [_createElementVNode("div", _hoisted_6, [_ctx.check ? (_openBlock(), _createElementBlock("i", _hoisted_7)) : _createCommentVNode("", true), item.srcTyp === '1' ? (_openBlock(), _createBlock(_component_el_image, {
        key: 1,
        fit: "contain",
        style: {
          "width": "100%",
          "height": "100%"
        },
        src: item.srcOutUrl ? item.srcOutUrl : item.srcInnUrl
      }, null, 8, ["src"])) : _createCommentVNode("", true), item.srcTyp === '2' ? (_openBlock(), _createElementBlock("audio", {
        key: 2,
        style: {
          "width": "100%",
          "height": "100%",
          "position": "absolute",
          "bottom": "50%"
        },
        src: item.srcOutUrl ? item.srcOutUrl : item.srcInnUrl,
        controls: "controls"
      }, null, 8, _hoisted_8)) : _createCommentVNode("", true), item.srcTyp === '3' ? (_openBlock(), _createElementBlock("video", {
        key: 3,
        style: {
          "width": "100%",
          "height": "100%"
        },
        src: item.srcOutUrl ? item.srcOutUrl : item.srcInnUrl,
        muted: "",
        controls: "controls"
      }, " 您的浏览器不支持 HTML5 video 标签。 ", 8, _hoisted_9)) : _createCommentVNode("", true), item.srcTyp === '7' ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.content), 1)) : _createCommentVNode("", true), item.srcTyp !== '1' && item.srcTyp !== '2' && item.srcTyp !== '3' && item.srcTyp !== '7' ? (_openBlock(), _createElementBlock("img", {
        key: 5,
        fit: "contain",
        style: {
          "width": "100%",
          "height": "100%"
        },
        src: _ctx.srcType[item.srcTyp] && _ctx.srcType[item.srcTyp].src ? _ctx.srcType[item.srcTyp].src : _ctx.srcType[6].src
      }, null, 8, _hoisted_11)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_cache[13] || (_cache[13] = _createTextVNode("活动名称：", -1)), _createElementVNode("span", null, _toDisplayString(item.actName), 1)]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createTextVNode("素材名称：", -1)), _createElementVNode("span", null, _toDisplayString(item.assetsName), 1)]), _createElementVNode("div", null, [_cache[15] || (_cache[15] = _createTextVNode("素材类型：", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.srcType[item.srcTyp].typ), 1)]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createTextVNode("投放时间：", -1)), _createElementVNode("span", null, _toDisplayString(item.createTime), 1)]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createTextVNode("开始时间：", -1)), _createElementVNode("span", null, _toDisplayString(item.bgnDate), 1)]), _createElementVNode("div", null, [_cache[18] || (_cache[18] = _createTextVNode("结束时间：", -1)), _createElementVNode("span", null, _toDisplayString(item.endDate), 1)]), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createTextVNode("必须投放：", -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(item.mustPut === 1 ? '是' : '否'), 1)])]), !(item.srcTyp === '4' || item.srcTyp === '7') ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        loading: _ctx.isDownloading && _ctx.downId == item.id,
        class: "btn",
        type: "primary",
        size: "small",
        onClick: $event => $setup.downloadAssets(item.assetsId)
      }, {
        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("下载本素材", -1)]))]),
        _: 1
      }, 8, ["loading", "onClick"])), [[_directive_has, 'put:list:one:down']]) : _createCommentVNode("", true)])], 10, _hoisted_5);
    }), 128))]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_pagination, {
      onSizeChange: $setup.handleSizeChange,
      onCurrentChange: $setup.handleCurrentChange,
      "page-sizes": [10, 20, 30, 40, 50],
      "page-size": _ctx.pageSize,
      total: _ctx.tableTotal,
      currentPage: _ctx.pageNo,
      layout: "total,prev, pager, next, sizes, jumper"
    }, null, 8, ["onSizeChange", "onCurrentChange", "page-size", "total", "currentPage"])])]),
    _: 1
  });
}